"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAndFilter = exports.isOrFilter = exports.isBinaryFilter = exports.isUnaryFilter = exports.isBinaryOperator = exports.isUnaryOperator = exports.operators = exports.binaryOperators = exports.unaryOperators = void 0;
exports.unaryOperators = ['set', 'notSet'];
exports.binaryOperators = [
    'equals',
    'notEquals',
    'contains',
    'notContains',
    'gt',
    'gte',
    'lt',
    'lte',
];
exports.operators = [
    ...exports.unaryOperators,
    ...exports.binaryOperators,
];
const isUnaryOperator = (operator) => {
    return exports.unaryOperators.includes(operator);
};
exports.isUnaryOperator = isUnaryOperator;
const isBinaryOperator = (operator) => {
    return exports.binaryOperators.includes(operator);
};
exports.isBinaryOperator = isBinaryOperator;
const isUnaryFilter = (filter) => {
    return (0, exports.isUnaryOperator)(filter.operator);
};
exports.isUnaryFilter = isUnaryFilter;
const isBinaryFilter = (filter) => {
    return (0, exports.isBinaryOperator)(filter.operator);
};
exports.isBinaryFilter = isBinaryFilter;
const isOrFilter = (filter) => {
    return !!filter.or;
};
exports.isOrFilter = isOrFilter;
const isAndFilter = (filter) => {
    return !!filter.and;
};
exports.isAndFilter = isAndFilter;
//# sourceMappingURL=types.js.map